/**
 * Milestones feature configuration.
 *
 * MILESTONES_ENABLED is the client release flag for staged rollout. It gates
 * mounting/UI only — it is NOT authorization (server RPCs enforce permissions).
 * Set EXPO_PUBLIC_MILESTONES_ENABLED=true in the environment to enable.
 */
// A global override lets internal builds and E2E tests flip the flag without
// rebundling EXPO_PUBLIC_* (e.g. `window.__MILESTONES_ENABLED__ = true` via
// Playwright addInitScript). Still presentation-only — never authorization.
export const MILESTONES_ENABLED =
    process.env.EXPO_PUBLIC_MILESTONES_ENABLED === 'true' ||
    globalThis.__MILESTONES_ENABLED__ === true;

/** Milestone scopes (matches the backend contract — do not localize). */
export const MILESTONE_SCOPES = {
    ORGANIZATION: 'ORGANIZATION',
    INDIVIDUAL: 'INDIVIDUAL',
};

/** Presentation defaults shared by management, profile, and celebration UI. */
export const MILESTONE_PRESENTATION = {
    /** Page size for definition/state/history reads. */
    pageSize: 50,
    /** Max series per claimed celebration batch (Phase E). */
    celebrationClaimLimit: 20,
    /** Foreground pending-state fallback across authenticated app screens.
     *  Passive poll only — same-device triggers refetch immediately via the
     *  mutation-cache invalidation in AchievementHost. */
    celebrationPollMs: 120000,
    /** Active-day recheck cadence while the app stays foregrounded (Phase E). */
    activeDayRecheckMs: 5 * 60 * 1000,
    /** Fallbacks used when a catalog has not loaded or omits allowlists. */
    defaultBadgeIcon: 'ribbon-outline',
    defaultBadgeColorToken: 'primary',
    defaultTitle: 'Congratulations!',
    /** Client-side sanity bounds; the server catalog remains authoritative. */
    fallbackThresholdBounds: { min: 1, max: 25, minValue: 1, maxValue: 1000000000 },
    fallbackTextBounds: { name: { min: 1, max: 120 }, title: { min: 0, max: 160 }, message: { min: 0, max: 600 } },
};
